import { useMemo, useRef } from "react"

import { useFormSubmit } from "shared/lib/useFormSubmit"
import { FormRef } from "shared/types/ReactHookForm"

import { CreateTeamMemberFormData } from "features/team-member-management/types/CreateTeamMemberFormData"
import { CreateTeamMemberFormModel } from "features/team-member-management/ui/create-team-member-form"

import { CreateProjectTeamMembersOverlayProps } from "../CreateProjectTeamMembersOverlay"
import { CreateProjectTeamMembersOverlayViewModel } from "../ui/CreateProjectTeamMembersOverlayView"

export function useCreateProjectTeamMembersOverlayViewModel({
  defaultValue,
  onSubmit,
  onCancel,
  currentUserEmail,
  existingTeamMemberEmails
}: CreateProjectTeamMembersOverlayProps): CreateProjectTeamMembersOverlayViewModel {
  const formRef: FormRef<CreateTeamMemberFormData> = useRef(null)

  const { handleSubmit, isSubmitting } = useFormSubmit({
    onSubmit,
    onSuccess: onCancel,
    formRef
  })

  const formModel = useMemo<CreateTeamMemberFormModel>(
    () => ({
      defaultValue,
      currentUserEmail,
      existingTeamMemberEmails,
      onSubmit: handleSubmit
    }),
    [defaultValue, currentUserEmail, existingTeamMemberEmails, handleSubmit]
  )

  return {
    formID: "project-team-invites-overlay-form",
    formModel,
    isSubmitting,
    onCancel
  }
}
